import { Helmet } from "react-helmet-async"
import { MailSendsUsageView } from "../../../MailMessages"

export default function CreditConsumptionEmailSendPage() {
	return (
		<>
			<Helmet>
				<title>Email Send Credits</title>
			</Helmet>
			<MailSendsUsageView />
		</>
	)
}
